import './Loader.css';

function Loader() {
    return <div className="loader">
        <div className='top back left'/>
        <div className='top back right'/>
        <div className='top front left'/>
        <div className='top front right'/>
        <div className='side negative back'/>
        <div className='side positive back'/>
        <div className='side positive front'>Wird geladen</div>
        <div className='side negative front'>Loading</div>
        <div className='bottom'/>
    </div>
}

export default Loader;